// The `code` on a refused report email send (the API's EmailRefusalCodes). The report toolbar words
// the message itself, so these values are a contract with the API - rename one and both sides move.
export enum EmailRefusalCodes {
  // A file configured on the document's Attachments tab could not be read, so nothing was sent.
  attachmentUnreadable = 'AttachmentUnreadable',
}
